import styled from '@emotion/styled'
import * as v from '../../../variables/styles'

export const OverlayBody = styled.div`
  display: flex; 
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  font-family: 'IBM Plex Sans Thai';
  font-size: 1.25rem;
  font-weight: bold;
  color: #FFF;

  .bp3-spinner {
    margin-bottom: 8px;
  }

  path.bp3-spinner-head {
    stroke: ${v.ezMainColor};
  }
` 
